<template>
  <div class="bsp-call">
    <div class="call-container">
      <div class="call-header">
        <h2>Active Call</h2>
        <b-button variant="danger" @click="confirmEndCall">End Call</b-button>
      </div>

      <BSPStatusIndicator :is-listening="isListening" />
      <BSPAudioVisualizer :is-active="isListening" />

      <BSPTranscript :messages="transcript" />
    </div>
  </div>
</template>

<script>
import BSPStatusIndicator from "./BSPStatusIndicator.vue"
import BSPTranscript from "./BSPTranscript.vue"
import BSPAudioVisualizer from "./BSPAudioVisualizer.vue"

export default {
  name: "BSPCall",
  components: {
    BSPStatusIndicator,
    BSPTranscript,
    BSPAudioVisualizer
  },
  props: {
    isListening: {
      type: Boolean,
      default: false
    },
    transcript: {
      type: Array,
      required: true
    }
  },
  methods: {
    confirmEndCall () {
      this.$bvModal.msgBoxConfirm("Are you sure you want to end the call?", {
        title: "End Call",
        okVariant: "danger",
        okTitle: "Yes, end call",
        cancelTitle: "No, continue call",
        hideHeaderClose: false,
        centered: true
      })
        .then(value => {
          if (value) {
            this.endCall()
          }
        })
    },
    endCall () {
      this.$emit("end-call")
    }
  }
}
</script>

<style lang="scss" scoped>
.bsp-call {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.call-container {
  background-color: $white;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  padding: 1.5rem;
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.call-header {
  display: flex;
  justify-content: space-between;
  align-items: center;

  h2 {
    margin: 0;
    font-size: 1.5rem;
    font-weight: 600;
    color: $slate80;
  }

  .btn-danger {
    padding: 0.5rem 1.5rem;
    font-weight: 500;
    border-radius: 6px;
    transition: all 0.2s ease;

    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 4px 12px rgba($red, 0.2);
    }

    &:active {
      transform: translateY(0);
    }
  }
}
</style>
